<template>
  <div class="col-12">
    <div class="mx-1" v-if="noRefiere">NO REFIERE</div>

    <b-table
      v-if="antFamiliares.antecedentes.length > 0 && !noRefiere"
      :items="antFamiliares.antecedentes"
      :fields="tableFields"
      class="text-center"
      responsive
      small
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>
    </b-table>

    <div
      v-if="!noRefiere && antFamiliares.observaciones"
      class="mt-2"
    >
      Observaciones: {{ antFamiliares.observaciones }}
    </div>
  </div>
</template>

<script>
import { anamnesisService } from '@/views/atencionMedica/services';

export default {
  name: "AntFamiliaresTable",

  props: {
    tokenAtencion: {
      type: String,
      required: true
    },

    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      antFamiliares: {
        antecedentes: [],
        observaciones: ''
      },

      tableFields: [
        {
          key: "index",
          label: "N°",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "antescedentesFamiliares.descripcion",
          label: "Antecedente",
          thClass: "text-center"
        },
        {
          key: "familiar",
          label: "Familiar",
          thClass: "text-center"
        },
        {
          key: "descripcionGeneral",
          label: "Descripción",
          thClass: "text-center"
        }
      ]
    };
  },

  computed: {
    noRefiere() {
      const antecedentes = this.antFamiliares.antecedentes;

      // Se considera que "no refiere" si hay un solo antecedente vacío
      const validation = antecedentes.length === 1 && !antecedentes[0].antescedentesFamiliares;

      return validation;
    }
  },

  methods: {
    async loadData() {
      if (!this.tokenAtencion) return;
      this.antFamiliares = await anamnesisService.getAntFamiliaresByAtencion(this.tokenAtencion);
    },

    emitHasData() {
      const hasData =
        this.antFamiliares.antecedentes.length > 0 ||
        !!this.antFamiliares.observaciones;

      this.$emit('input', hasData);
    }
  },

  watch: {
    tokenAtencion: {
      deep: true,
      handler: 'loadData'
    },

    antFamiliares: {
      deep: true,
      handler() {
        this.emitHasData();
      }
    }
  },

  created() {
    this.loadData();
  }
};
</script>
